import { useLocation, useParams } from "react-router";
import { entryNumberOfFragment } from "../../../shared/routing/appPaths";
import ErrorNotice from "../../../errors/ErrorNotice";
import ThreadView from "./ThreadView";

/**
 * `/threads/<id>[#<entry>]`, and `/threads/<id>/host-offers/<offer>` for a host offer's
 * recipient. The subject document or the data model beside it is the split view's job
 * (F34, WA-10); old `?beside=` links are translated by the workspace owner.
 */
export default function ThreadPage() {
  const { threadId, offerId } = useParams();
  const location = useLocation();

  if (threadId === undefined) {
    return <ErrorNotice error={{ kind: "invalidAddress", address: location.pathname }} className="p-4" />;
  }
  return (
    <div className="mx-auto max-w-4xl py-4">
      <ThreadView key={threadId} threadId={threadId} highlightedEntry={entryNumberOfFragment(location.hash)} addressKey={location.key} hostOfferId={offerId ?? null} />
    </div>
  );
}
